import { createAppModule } from "./app/app.module";
import { dynamicEnvironment } from "./environments/environment";

dynamicEnvironment
    .asyncPlatformBrowserDynamic()
    .then(([platform, environment]) => platform.bootstrapModule(createAppModule(environment)).catch((error) => console.error(error)));
